@if (dashboard) {
  <div class="data-dashboard"
    >
    @if (dashboard.mainWidget) {
      <div
        class="data-dashboard__main">
        @for (item of dashboard.mainWidget.items; track item) {
          <sb-summary-button
            [summary]="item"
          (onClick)="openRoute(item.url)"></sb-summary-button>
        }
      </div>
    }
    <div class="data-dashboard__widgets">
      @for (widget of dashboard.otherWidgets; track widget) {
        <div
          class="data-dashboard__widget data-dashboard__widget--{{widget.cols}}">
          <div class="data-dashboard__widget__header">
            <h2 [innerHTML]="widget.title"></h2>
            <div>
              @if (widget.url) {
                <sb-button
                  [isAutoSize]="true"
                  [message]="'SB_View_All' | translate"
                  buttonClass="primary"
                (onClick)="openRoute(widget.url)"></sb-button>
              }
            </div>
          </div>
          @if (widget.items) {
            <div
              class="data-dashboard__widget__items">
              @for (item of widget.items; track item) {
                <sb-summary-button
                  [summary]="item"
                (onClick)="openRoute(item.url)"></sb-summary-button>
              }
            </div>
          }
          @if (widget.chart) {
            <sb-chart
            [chartOption]="widget.chart"></sb-chart>
          }
          @if (widget.table) {
            <sb-data-table
              [tableColumns]="widget.table.columns"
              [tableData]="widget.table.data"
            [pageSize]="widget.table.pageSize || 10"></sb-data-table>
          }
        </div>
      }
      @if (dashboard.links) {
        <div
          class="data-dashboard__links">
          <h2 [innerHTML]="'SB_More' | translate"></h2>
          <sb-action-menu [isFeatured]="true"
          [menuItems]="dashboard.links"></sb-action-menu>
        </div>
      }
    </div>
  </div>
}